import { createSelector } from 'reselect';
import { teamName as teamNameSelect } from './config';
import { users } from './entities';
import { getFileUrl } from '../util/url';

// Returns user session if valid, undefined if not
export const session = ({ session = {} } = {}) =>
  session.userID ? session : undefined;

export const isSessionAdminOrOwner = createSelector(
  session,
  (session = {}) => session.isTeamOwner || session.isTeamAdmin
);

export const teamName = createSelector(
  session,
  teamNameSelect,
  ({ teamName } = {}, teamNameSelect) => teamName || teamNameSelect
);

export const userID = createSelector(session, ({ userID } = {}) => userID);

export const userKey = createSelector(session, ({ userKey } = {}) => userKey);

export const user = createSelector(
  [users, userID],
  (users = {}, userID) => users[userID] || {}
);

export const notificationPreference = createSelector(
  user,
  (user = {}) => user.notificationPreference
);

export const experience = createSelector(user, (user = {}) => user.experience);

export const phone = createSelector(user, (user = {}) => user.phone);

export const username = createSelector(
  session,
  ({ username } = {}) => username
);

export const email = createSelector(user, ({ email }) => email);

export const fullName = createSelector(user, ({ fullName }) => fullName);

export const slack = createSelector(user, ({ slackUsername }) => slackUsername);

export const userThumbnail = createSelector(
  user,
  teamName,
  ({ userThumbnail }, teamName) =>
    !userThumbnail ? userThumbnail : getFileUrl(teamName, userThumbnail)
);

export const isTeamOwner = createSelector(
  user,
  ({ isTeamOwner }) => isTeamOwner
);

export const inviteID = createSelector(session, ({ inviteID }) => inviteID);

export const isTeamAdmin = createSelector(
  user,
  (user = {}) => user.isTeamAdmin
);

export const isAdminOrOwner = createSelector(
  isTeamOwner,
  isTeamAdmin,
  (owner, admin) => owner || admin
);

export const newlyAuthenticated = createSelector(
  session,
  ({ newlyAuthenticated } = {}) => !!newlyAuthenticated
);

export const newlyAuthenticatedSSO = createSelector(
  session,
  ({ newlyAuthenticatedSSO } = {}) => !!newlyAuthenticatedSSO
);



// WEBPACK FOOTER //
// ./js/selectors/session.js